import Vue from 'vue'
import Vuex from 'vuex'

import { LoginStore } from "./login.store.js";
import { ConfigStore } from "./Config/config.store.js";
import { ListarCategoriasActivasComercios } from "./Comercios/ListarCategoriasActivasComerciosStore.js";
import { ListarComercios } from "./Comercios/ListarComerciosStore.js";
import { FotosComercios } from "./Comercios/FotosComerciosStore.js";
import { ObtenerProductoCancelar } from "./Reservas/ObtenerProductoCancelarStore.js";


Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        LoginStore,
        ConfigStore,        
        ListarCategoriasActivasComercios,
        ListarComercios,
        FotosComercios,
        ObtenerProductoCancelar,
    }
})